import { render, staticRenderFns } from "./Tausendstel.vue?vue&type=template&id=8056e6c6&"
import script from "./Tausendstel.vue?vue&type=script&lang=js&"
export * from "./Tausendstel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports